// extracted by mini-css-extract-plugin
export var ScaleAndBlur = "loop-dot-module--ScaleAndBlur--b5f6b";
export var loopDot = "loop-dot-module--loop-dot--4021d";
export var loopDotBottom = "loop-dot-module--loop-dot--bottom--11fcc";
export var loopDotIsActive = "loop-dot-module--loop-dot--is-active--5f4fb";
export var loopDotLeft = "loop-dot-module--loop-dot--left--0f12a";
export var loopDotRight = "loop-dot-module--loop-dot--right--90939";
export var loopDotTop = "loop-dot-module--loop-dot--top--b911e";
export var mt0 = "loop-dot-module--mt-0--2e8fd";
export var mt1 = "loop-dot-module--mt-1--7b52a";
export var mt2 = "loop-dot-module--mt-2--10618";
export var mt3 = "loop-dot-module--mt-3--7e919";
export var mt4 = "loop-dot-module--mt-4--226cd";
export var mt5 = "loop-dot-module--mt-5--5a18a";
export var mt6 = "loop-dot-module--mt-6--cad17";